import { SettingsCard } from '../../components/settings-card'
import { TabLayout } from '../../layouts/tab'
import { CurrentSubscription } from '../../components/billing/current-subscription'
import { PaymentMethod } from '../../components/billing/payment-method'
import { BillingHistory } from '../../components/billing/billing-history'
import { Breadcrumb } from '$components'
import { SettingsIcon } from '$components'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { usePageTitle } from '$components'

const dummyData = {
  subscription: {
    plan: 'Professional',
    nextRenewal: '2024-02-01',
    status: 'active' as const,
  },
  paymentMethod: {
    last4: '4242',
    expiryDate: '12/24',
  },
  billingHistory: [
    {
      date: 'Jan 1, 2024',
      amount: 29.00,
      status: 'paid' as const,
    },
    {
      date: 'Dec 1, 2023',
      amount: 29.00,
      status: 'paid' as const,
    },
    {
      date: 'Nov 1, 2023',
      amount: 29.00,
      status: 'paid' as const,
    },
  ],
}

export function BillingTab() {
  // Set page title for billing settings tab
  usePageTitle('Settings - Billing')

  return (
    <TabLayout>
      <Breadcrumb
        items={[
          {
            label: 'Settings',
            icon: SettingsIcon,
            path: SettingsRoutePath.Settings,
          },
          {
            label: 'Billing',
            path: SettingsRoutePath.SettingsBilling,
          },
        ]}
      />

      <div className="space-y-6">
        <SettingsCard>
          <SettingsCard.Heading>Current Subscription</SettingsCard.Heading>
          <SettingsCard.Subheading>
            Manage your subscription plan and billing cycle
          </SettingsCard.Subheading>
          <CurrentSubscription data={dummyData.subscription} />
        </SettingsCard>

        <SettingsCard>
          <SettingsCard.Heading>Payment Method</SettingsCard.Heading>
          <SettingsCard.Subheading>
            Manage your payment details and billing address
          </SettingsCard.Subheading>
          <PaymentMethod data={dummyData.paymentMethod} />
        </SettingsCard>

        <SettingsCard>
          <SettingsCard.Heading>Billing History</SettingsCard.Heading>
          <SettingsCard.Subheading>
            View and download your past invoices
          </SettingsCard.Subheading>
          <BillingHistory data={dummyData.billingHistory} />
        </SettingsCard>
      </div>
    </TabLayout>
  )
}
